import type {
  ArrayColumnPlacementV2,
  ColumnPlacementV2,
  DivisionColumnPlacementV2,
  MaxDistanceColumnPlacementV2,
  ParamColumnPlacementV2,
} from "building-types/columns/columnTypes";
import { ColumnPlacementType } from "building-types/columns/columnTypesEnum";
import { assertUnreachable } from "common/utils/assertUnreachable";

export function paramColumnPlacementV2New(): ParamColumnPlacementV2 {
  return {
    type: ColumnPlacementType.PARAM,
  };
}

export function arrayColumnPlacementV2New(
  spacing: number = 24,
  shift: number = 24,
  maxCount?: number,
): ArrayColumnPlacementV2 {
  return {
    type: ColumnPlacementType.ARRAY,
    spacing,
    shift,
    maxCount,
  };
}

export function divisionColumnPlacementV2New(segments: number = 2): DivisionColumnPlacementV2 {
  return {
    type: ColumnPlacementType.DIVISION,
    segments,
  };
}

export function maxDistanceColumnPlacementV2New(maxDistance: number = 24): MaxDistanceColumnPlacementV2 {
  return {
    type: ColumnPlacementType.MAX_DISTANCE,
    maxDistance,
  };
}

export function columnPlacementNameNew(columnPlacementType: ColumnPlacementType) {
  switch (columnPlacementType) {
    case ColumnPlacementType.PARAM:
      return "Columns by Param";
    case ColumnPlacementType.ARRAY:
      return "Columns by Array";
    case ColumnPlacementType.DIVISION:
      return "Columns by Division";
    case ColumnPlacementType.MAX_DISTANCE: {
      return "Columns by Max Distance";
    }
    default:
      assertUnreachable(columnPlacementType);
  }
}

export function defaultColumnPlacementV2(columnPlacementType: ColumnPlacementType): ColumnPlacementV2 {
  switch (columnPlacementType) {
    case ColumnPlacementType.PARAM:
      return paramColumnPlacementV2New();
    case ColumnPlacementType.ARRAY:
      return arrayColumnPlacementV2New();
    case ColumnPlacementType.DIVISION:
      return divisionColumnPlacementV2New();
    case ColumnPlacementType.MAX_DISTANCE: {
      return maxDistanceColumnPlacementV2New();
    }
    default:
      assertUnreachable(columnPlacementType);
  }
}
